import { useContext } from "react";
import { ThemeToggle, ThemeToggleContext } from "../contexes/DarkModeContext";

export function useThemeMode(): ThemeToggle {
  return useContext(ThemeToggleContext);
}
